<template>
  <div style="height: 100%;" class="position-rel">
    <v-card class="document-folder-history-dialog" elevation="0" style="font-family: 'Montserrat';">
      <v-toolbar color="#F9FAFD" dark class="toolbar-card" style="height: 80px;">
        <v-toolbar-title style="font-size: 24px; font-weight: 600; line-height: 32px; height: 32px; color: #161A40; font-family: 'Montserrat';">Complaint List</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon small @click="showHistory()" color="#ffffff">
          <img
            :src="computeRefreshLogo"
            alt="Refresh"
            class="height-24"
          />
        </v-btn>
      </v-toolbar>
      <v-container class="height-100-b content" style="height: auto; min-height: 800px;">
        <v-card color="#F9FAFD" class="mb20 pdb20" v-for="(item, index) of dataForm" :key="index">
          <v-list-item three-line>
            <v-list-item-avatar
            size="60"
            color="green"
            >
              <v-icon dark large>
                mdi-account-circle
              </v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>
                {{ name }}
              </v-list-item-title>
              <v-list-item-subtitle>
                <v-chip class="ml-0 padding-5" color="green" text-color="white" label v-if="item.commentsStatus === 1">
                  RESOLVED
                </v-chip>
                <v-chip class="ml-0 padding-5" color="rgb(255,153,0)" text-color="white" label v-if="item.commentsStatus === 2">
                  UNCONTACTABLE
                </v-chip>
                <v-chip class="ml-0 padding-5" color="rgb(244,67,54)" text-color="white" label v-if="item.commentsStatus === 3">
                  DISAGREE
                </v-chip>
                <v-chip class="ml-0 padding-5" color="rgb(158,158,158)" text-color="white" label v-if="item.commentsStatus === 0">
                  NEW
                </v-chip>
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-content class="tr">
              <v-list-item-subtitle>{{ item.complaintSource }} {{ item.createdAt }}</v-list-item-subtitle>
              <v-list-item-subtitle>{{ item.complaintType }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item class="btc">
            {{ item.complaintContent }}
          </v-list-item>
          <v-list-item class="pd20 cont-flex" v-for="(content, i) of item.loanCommentRecordList" :key="i">
            <div class="title-flex">
              <div>Reply from {{  content.commentsOperatedBy }}</div>
              <div>{{ content.createdAt }}</div>
            </div>
            <div>
              {{ content.commentsContent }}
            </div>
          </v-list-item>
          <div class="m-l-90">
            <v-btn @click="showDialog(item.complaintCode,item.complaintRecordId)" :disabled="item.commentsStatus === 1 ? true : false">
              REPLY
            </v-btn>
          </div>
        </v-card>
      </v-container>
    </v-card>
    <div class="b-btn">
      <v-btn class="m-l-90" @click="resolve" :disabled="this.canDoResolve === -1 ? true : false">
        RESOLVE
      </v-btn>
    </div>
    <v-dialog
      max-width="600"
      persistent
      v-model="complaintDialog"
    >
      <template>
        <v-card>
          <v-toolbar
            color="primary"
            dark
          >
            <div>
              <v-toolbar-title style="font-size: 24px;font-weight: 400">Reply</v-toolbar-title>
              <div>Please enter the reply content and select the submission method.</div>
            </div>
            <v-btn
              icon
              dark
              @click="closeComplaintDialog"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <template>
              <v-col
                cols="12"
              >
                <v-textarea
                  outlined
                  name="input-7-4"
                  label="Complaint Response"
                  v-model='response'
                ></v-textarea>
              </v-col>
            </template>
          </v-card-text>
          <v-card-actions class="justify-end">
            <v-btn
              text
              color="rgb(0,150,135)"
              @click="reply(1)"
            >RESOLVED</v-btn>
            <v-btn
              text
              color="rgb(255,153,0)"
              @click="reply(2)"
            >UNCONTACTABLE</v-btn>
            <v-btn
              text
              color="rgb(244,67,54)"
              @click="reply(3)"
            >DISAGREED</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>
<!--    warningDialog-->
    <v-dialog
      v-model="dialogWarning"
      width="512"
      persistent
      class="dialogFlex"
    >
      <div class="warningComplaint" aria-live="assertive" aria-modal="true">
        <div class="icon-top"
        >
          <div class="swal2-icon swal2-warning swal2-animate-warning-icon" style="display: flex">
            <span class="swal2-icon-text">
              !
            </span>
          </div>
        </div>
        <div class="swal2-content">
          <div id="swal2-content" style="font-family: '等线'; font-size: 20px; font-weight: normal">
            {{ warningTitle }}
          </div>
        </div>
        <v-btn
          class="mb-bottom"
          color="primary"
          text
          depressed
          @click="dialogWarning = false"
        >
          OK
        </v-btn>
      </div>
    </v-dialog>
<!--    questionDialog-->
    <v-dialog
      v-model="dialogQuestion"
      width="512"
      persistent
      class="dialogFlex"
    >
      <div class="warningComplaint" aria-live="assertive" aria-modal="true">
        <div class="swal2-header icon-top"
        >
          <div class="swal2-icon swal2-question swal2-animate-question-icon" style="display: flex">
            <span class="swal2-icon-text">
              ?
            </span>
          </div>
        </div>
        <div class="swal2-content">
          <div id="swal2-content" style="font-family: '等线'; font-size: 20px; font-weight: normal">
            {{ title }}
          </div>
        </div>
        <div class="swal2-actions" style="display: flex">
          <v-btn
            class="mb-bottom swal2-confirm swal2-styled"
            style="border-left-color: rgba(43, 21, 21, 0); border-right-color: rgba(43, 21, 21, 0);"
            aria-label
            color="primary"
            text
            depressed
            @click="send"
          >
            OK
          </v-btn>
          <v-btn
            class="mb-bottom swal2-cancel swal2-styled"
            aria-label
            style="display: inline-block;"
            color="primary"
            text
            depressed
            @click="dialogQuestion = false"
          >
            Cancel
          </v-btn>
        </div>
      </div>
    </v-dialog>
<!--    successDialog-->
    <v-dialog
      v-model="dialogSuccess"
      width="512"
      persistent
      class="dialogFlex"
    >
      <div class="warningComplaint" aria-live="assertive" aria-modal="true">
        <div class="swal2-header icon-top"
        >
          <div class="swal2-icon swal2-success swal2-animate-success-icon" style="display: flex">
            <div class="swal2-success-circular" style="background-color: rgb(255, 255, 255);">
              <span class="swal2-success-line-tip"></span>
              <span class="swal2-success-line-long"></span>
              <div class="swal2-success-ring"></div>
            </div>
          </div>
        </div>
        <div class="swal2-content">
          <div id="swal2-content" style="font-family: '等线'; font-size: 20px; font-weight: normal">
            Are you sure to reply?
          </div>
        </div>
        <div class="swal2-actions" style="display: flex">
          <v-btn
            class="mb-bottom swal2-confirm swal2-styled"
            style="border-left-color: rgba(43, 21, 21, 0); border-right-color: rgba(43, 21, 21, 0);"
            aria-label
            color="primary"
            text
            depressed
            @click="dialogSuccess = false"
          >
            OK
          </v-btn>
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import { DataType, Tool } from '@/util/index'
import refreshImg from '@/assets/icons/icon_refresh@3x.png'
import { ComplaintApi } from '@/api/lms/complaint'
import { SystemEnum } from '@/assets/js'

const tool = new Tool()

export default {
  name: 'complaint-handling',
  data () {
    return {
      dialogWarning: false,
      dialogQuestion: false,
      dialogSuccess: false,
      complaintDialog: false,
      dataForm: [],
      loanId: 0,
      complaintCode: '',
      complaintRecordId: '',
      response: '',
      replayDisabled: false,
      canDoResolve: '',
      assist: {
        tool: new Tool(),
        sectionFeature: SystemEnum.SECTION_FEATURE,
        DataType: DataType
      },
      name: '',
      title: '',
      flag: 0,
      warningTitle: ''
    }
  },
  computed: {
    computeRefreshLogo () {
      return refreshImg
    }
  },
  methods: {
    showDialog (complaintCode, complaintRecordId) {
      this.complaintCode = complaintCode
      this.complaintRecordId = complaintRecordId
      this.complaintDialog = true
    },
    getComplaintDetail () {
      const $this = this
      $this.dataForm = []
      const input = {
        loanId: this.$store.getters.getLoan.loanId,
        loanCommentsStatusList: '0,1,2,3'
      }
      ComplaintApi.getComplaintDetail(input, function (result) {
        $this.canDoResolve = result.canDoResolve
        $this.name = result.customerName
        if (tool.isNotEmpty(result.items)) {
          result.items.map(value => {
            value.createdAt = `${tool.formatDateTime(value.createdAt).substring(10)}  ${tool.formatDateTime(value.createdAt).substring(0, 10)}`
            if (tool.isNotEmpty(value.loanCommentRecordList)) {
              value.loanCommentRecordList.map(next => {
                next.createdAt = `${tool.formatDateTime(next.createdAt).substring(10)}  ${tool.formatDateTime(next.createdAt).substring(0, 10)}`
              })
            }
          })
          DataType.ComplaintSource.forEach((item, index) => {
            result.items.forEach((content, i) => {
              if (item.value === content.complaintSource) {
                content.complaintSource = item.text
              }
            })
          })
          DataType.ComplaintType.forEach(item => {
            result.items.forEach(content => {
              if (item.value === content.complaintType) {
                content.complaintType = item.text
              }
            })
          })
          $this.dataForm = result.items
        }
      })
    },
    reply (e) {
      this.flag = e
      if (!tool.isEmpty(this.response)) {
        this.dialogQuestion = true
        this.title = 'Are you sure to reply ?'
      } else {
        this.dialogWarning = true
        this.warningTitle = 'Comments cannot be empty.'
      }
    },
    send () {
      const $this = this
      if (this.flag !== 4) {
        const input = {
          loanId: this.$store.getters.getLoan.loanId,
          complaintRecordId: this.complaintRecordId,
          complaintCode: this.complaintCode,
          commentsStatus: this.flag,
          commentsContent: this.response
        }
        ComplaintApi.complaintReply(input, function () {
          $this.complaintDialog = false
          $this.dialogQuestion = false
          $this.response = ''
          $this.getComplaintDetail()
        }, function () {
          $this.response = ''
        })
      } else {
        ComplaintApi.complaintResolve({ loanId: this.$store.getters.getLoan.loanId }, function (result) {
          $this.dialogSuccess = true
          $this.dialogQuestion = false
          $this.getComplaintDetail()
        }, function (err) {
          $this.dialogQuestion = false
          $this.dialogWarning = true
          $this.warningTitle = err.message
        })
      }
    },
    resolve () {
      this.dialogQuestion = true
      this.title = 'Are you sure to resolve this loan ?'
      this.flag = 4
    },
    showHistory () {
      this.getComplaintDetail()
    },
    closeComplaintDialog () {
      this.complaintDialog = false
    }
  }
}
</script>
<style lang="scss" scoped>
  .document-folder-history-dialog .document {
    width: 160px;
    color: #002B7F;
    display: inline-block;
  }

  .document-folder-history-dialog .document-type {
    margin-bottom: 5px;
    font-size: 100px;
    line-height: 100px;
  }
  .document-folder-history-dialog .content {
    max-height: 800px;
    overflow: auto;
  }
  .toolbar-card.v-sheet.v-toolbar:not(.v-sheet--outlined) {
    box-shadow: none;
  }
  .cont-flex {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    background-color: #ffffff;
    border:1px solid #ccc ;
    margin: 10px;
    border-radius: 5px;
    min-height: auto;
  }
  .title-flex{
    width: 100%;
    display: flex;
    justify-content: space-between;
    font-size: 18px;
  }
  .tr {
    text-align: right;
  }
  .btc {
    border-top: 1px solid #CCC;
    border-bottom: 1px solid #CCC;
  }
  .mb20{
    margin-bottom: 20px;
  }
  .pd20 {
    padding-top: 15px;
    padding-bottom: 15px;
  }
  .pdb20 {
    padding-bottom: 10px;
    border-radius: 20px;
  }
  .padding-5{
    padding: 0 5px;
    height: 26px;
  }
  .b-btn{
    padding: 10px 0;
    width: 100%;
    background-color: #F9FAFD;
    position: fixed;
    bottom: 0;
  }
  .m-l-90{
    margin-left: 80%;
  }
  .info-complaint{
    border: 1px solid #ccc;
    margin-top: 20px;
    border-radius: 5px;
  }
  .warningComplaint {
    height: 290px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
    text-align: center;
    background-color: #fff;
  }
  .icon-top {
    margin-top: 40px;
  }
  .fz-center {
    font-size: 20px;
  }
  .mb-bottom {
    margin-bottom: 20px;
  }
</style>
<style>
.v-toolbar__content{
  justify-content: space-between;
}
.v-list-item__content {
  flex: auto;
}
</style>
